/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Execution_Pill_Dismiss_Aria_LabelInputs */

const en_toast_execution_pill_dismiss_aria_label = /** @type {(inputs: Toast_Execution_Pill_Dismiss_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss notification`)
};

const de_toast_execution_pill_dismiss_aria_label = /** @type {(inputs: Toast_Execution_Pill_Dismiss_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigung ausblenden`)
};

const pt_br2_toast_execution_pill_dismiss_aria_label = /** @type {(inputs: Toast_Execution_Pill_Dismiss_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispensar notificação`)
};

const tr_toast_execution_pill_dismiss_aria_label = /** @type {(inputs: Toast_Execution_Pill_Dismiss_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirimi kaldır`)
};

const zh_cn2_toast_execution_pill_dismiss_aria_label = /** @type {(inputs: Toast_Execution_Pill_Dismiss_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`忽略通知`)
};

const zh_hk2_toast_execution_pill_dismiss_aria_label = /** @type {(inputs: Toast_Execution_Pill_Dismiss_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`略過通知`)
};

const ko_kr2_toast_execution_pill_dismiss_aria_label = /** @type {(inputs: Toast_Execution_Pill_Dismiss_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알림 닫기`)
};

const ru_ru2_toast_execution_pill_dismiss_aria_label = /** @type {(inputs: Toast_Execution_Pill_Dismiss_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть уведомление`)
};

const es_419_toast_execution_pill_dismiss_aria_label = /** @type {(inputs: Toast_Execution_Pill_Dismiss_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar notificación`)
};

/**
* | output |
* | --- |
* | "Dismiss notification" |
*
* @param {Toast_Execution_Pill_Dismiss_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const toast_execution_pill_dismiss_aria_label = /** @type {((inputs?: Toast_Execution_Pill_Dismiss_Aria_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Execution_Pill_Dismiss_Aria_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toast_execution_pill_dismiss_aria_label(inputs)
	if (locale === "de") return de_toast_execution_pill_dismiss_aria_label(inputs)
	if (locale === "pt-BR") return pt_br2_toast_execution_pill_dismiss_aria_label(inputs)
	if (locale === "tr") return tr_toast_execution_pill_dismiss_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_toast_execution_pill_dismiss_aria_label(inputs)
	if (locale === "zh-HK") return zh_hk2_toast_execution_pill_dismiss_aria_label(inputs)
	if (locale === "ko-KR") return ko_kr2_toast_execution_pill_dismiss_aria_label(inputs)
	if (locale === "ru-RU") return ru_ru2_toast_execution_pill_dismiss_aria_label(inputs)
	return es_419_toast_execution_pill_dismiss_aria_label(inputs)
});